import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { Parent } from "./HXMobilePage.styles";
import { MobileApp, MobileAppWrapper } from "./AppView.styles";
import { CodeBlock, FlexColumn } from "./common.styles";
import { HXPageTitle } from "./HXDesktopPage";
import { Text } from "./HXDesktopPage.styles";
import { HeaderViewMobile } from "./HeaderViewMobile";
import { HXMobileButton } from "./HXButton";
import { ThemeProvider } from "@mui/material/styles";
import { createMuiTheme } from "./muiTheme";
import { appFonts } from "./AppView.styles";
import { StyleSheetManager } from "styled-components";
import { RouteErrorViewModel } from "./RouteErrorViewModel";
import { useViewModel } from "./useViewModel";
import { useEffect, useRef } from "react";
export const RouteErrorView = observer((props) => {
    var _a;
    const model = useViewModel(RouteErrorViewModel, props.container);
    const error = useRouteError();
    const hasRun = useRef(false);
    let errorMessage;
    let stack;
    if (isRouteErrorResponse(error)) {
        errorMessage = (_a = error.data) === null || _a === void 0 ? void 0 : _a.message;
    }
    else if (error instanceof Error) {
        errorMessage = error.message;
        stack = error.stack;
    }
    useEffect(() => {
        if (hasRun.current)
            return;
        hasRun.current = true;
        model.trackError(errorMessage, stack);
    }, []);
    return (_jsx(StyleSheetManager, { children: _jsx(ThemeProvider, { theme: createMuiTheme(appFonts), children: _jsxs(MobileAppWrapper, { showLoginGradient: false, children: [_jsxs(MobileApp, { children: [_jsx(HeaderViewMobile, { container: props.container, showLogoOnly: true }), _jsxs(Parent, { style: { padding: "0 32px 32px 32px", marginTop: 40 }, children: [_jsxs(FlexColumn, { gap: 24, alignItems: "center", children: [_jsx(HXPageTitle, { children: model.title }), _jsx(Text, { children: model.message })] }), _jsxs(FlexColumn, { gap: 12, children: [_jsx(HXMobileButton, { fullWidth: true, onClick: () => window.location.reload(), children: model.reloadButtonText }), _jsx(HXMobileButton, { text: true, fullWidth: true, onClick: () => model.goHome(), children: model.goHomeButtonText })] })] })] }), model.showStackTrace && !!stack && _jsx(CodeBlock, { style: { whiteSpace: "pre-wrap" }, children: stack })] }) }) }));
});
addDisplayName(RouteErrorView, "RouteErrorView");
